export default __webpack_public_path__ + "static/media/C280251.66366275.jpg";